<div class="modal-header">
  <h4 class="modal-title" style="color: white;">MÔI TRƯỜNG XANH, SẠCH, ĐẸP</h4>

  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div> 
<div class="modal-body">
  <ngx-extended-pdf-viewer [src]="pdfSrc" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer>
</div>